import React, { createContext, useContext, useState } from "react";
import { FormattedMessage } from "react-intl";
import DialogModal from "../../../components/dialogModal/dialogModal";
import "./_connectedApps.scss";
import FieldSkeleton from "../../../components/skeleton/FieldSkeleton";
import ListConnectedApps from "./connectedAppsPopup/listConnectedApps";
import { manageAppConsent } from "./connectedAppsService";
import { Button } from "@material-ui/core";

const ConnectedAppsContext = createContext();
export const useConnectedAppProps = () => useContext(ConnectedAppsContext);

const ConnectedApps = (props) => {
  let apps = props.consentedApps ;
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [filteredApps, setFilteredApps] = useState(apps); // filetered app list
  const [inputValue, setInputValue] = useState(""); // consented app list
  const [appStatus, setAppStatus] = useState("");  // pending, info, revoke, pending_revoke
  const [appInfo, setAppInfo] = useState({}); // app info of selected app
  const [currentApp, setCurrentApp] = useState(""); // user selected app id
  
  const handleClose = (event) => {
    event.preventDefault();
    setOpen(false);
  };

  const handleOpen = (event) => {
    event.preventDefault();
    setOpen(true);
    setError("");
    setAppStatus("");
    setInputValue("");
    setCurrentApp("");
    setAppInfo({});
    setFilteredApps(apps);
  }
  const handleInputChange = (event) => {
    event.preventDefault();
    let input_val = event.target.value;
    setInputValue(event.target.value);
    let updated_apps =
      input_val.length >= 2
        ? apps &&
          apps.filter((app) => app.application_name.toLowerCase().includes(input_val))
        : apps;
    setFilteredApps(updated_apps);
  };

  const handleViewAndEdit = (event,app_id) => {
    event.preventDefault();
    setAppStatus('pending');
    setCurrentApp(app_id);
    setAppInfo({});
    setError("");
    let post_data = {
      application_id: app_id,
    };
    /* API call to get app info */
    manageAppConsent(props.uuid, props.endpoints, post_data)
      .then((response) => {
        if(response && response.status === 200){
          let app_info = response.data;
          if (app_info && Object.keys(app_info).length > 0) {
            setAppInfo(app_info);
            setAppStatus("info");
          }else
            setAppStatus("");
        }else{
          setAppStatus("");
          if(response?.status === 401) 
            props.signOut();
          else
            setError(response?.data?.error ?? "default");
       }
    })
    .catch((error) => {
      setAppStatus("");
      setError("default");
    });

  };
  const handleAppAccess = (event, app_id, action) => {
     event.preventDefault();
     setAppStatus("");
     setInputValue("");
     setError("");
     setFilteredApps(apps);
    
     if(!action){
      setAppStatus("pending_revoke");
      let post_data = {
            application_id: app_id,
            action: "consent_revoked"
          };
    /* API call to revoke app consent */
     manageAppConsent(props.uuid, props.endpoints, post_data)
        .then((response) => {
          if(response?.status === 200){
          handleClose(event);
          props.reloadData();
          }else{
            setAppStatus("revoke");
            if(response?.status === 401) 
              props.signOut();
            else 
              setError(response?.data?.error ?? "default");
        }
      })
      .catch((error) => {
        setAppStatus("revoke");
        setError("default");
      });
  }else if (action === "revoke") {
    setAppStatus("revoke");
  }
  };
  
  return (
     <ConnectedAppsContext.Provider
     value={{
       apps,
       filteredApps,
       appInfo,
       appStatus,
       inputValue,
       currentApp,
       error,
       handleViewAndEdit,
       handleInputChange,
       handleAppAccess,
       handleClose
     }}
   >
    <div className={`line-break ${props.isnotFederatedUser ? ' account-holder' : ''}`}>
    
        <>
          <h4>
            <FormattedMessage defaultMessage="Third-party applications" />
          </h4>
          <div className="acc-text">
            <FormattedMessage defaultMessage="Manage third-party applications you shared data with." />
          </div>
         <div className="app-chip-section">
         {apps &&
           apps.map((app, i) => (
               i < 3 && 
             <div className="app-chip" key={i}>{app?.application_logo && <img src={app?.application_logo} width={24} height={24} className="app-logo" alt="application_logo"/>}{app.application_name}</div>
             ))
           }
           {apps.length > 3 && <div className="app-chip">+{apps.length - 3}</div>}
         </div>
        
          <div className="link-holder">
              <Button className="link custom-button buttonLink custom-button__focus" onClick={(e) => handleOpen(e)} disableRipple>
                <FormattedMessage defaultMessage="Manage app access ({appLength})" values={{ appLength : apps.length}} />
              </Button>
          </div>
        </>
      
       
 
      <DialogModal
        open={open}
        dialogBody={
          <ListConnectedApps/>
        }
      />
    </div>
    </ConnectedAppsContext.Provider>
  );
};

export default ConnectedApps;

